import { Box } from '@chakra-ui/react'
import { GreyGrey30, GreyGrey60, Lato12Bold } from '@sequencehq/design-tokens'
import { format, getMonth } from '@sequencehq/utils/dates'
import { useAtom } from 'jotai'
import { timelineMonthsAtom } from '../atoms/timeline.atom'
import { useTimelineDimensions } from '../hooks/useTimelineDimensions'

const MonthIndicator = (props: {
  date: Date
  offset: number
}) => {
  return (
    <Box
      height="23px"
      position="absolute"
      left={`${props.offset}px`}
      {...Lato12Bold}
      color={GreyGrey60}
      fontSize="10px"
      textTransform="uppercase"
    >
      <Box height="4px" borderLeft={`1px solid ${GreyGrey30}`}></Box>
      {format(props.date, getMonth(props.date) === 0 ? 'MMM yyyy' : 'MMM')}
    </Box>
  )
}

export const ScheduleTimelineMonths = () => {
  const [timelineMonths] = useAtom(timelineMonthsAtom)
  const { timelineWidth } = useTimelineDimensions()

  return (
    <Box
      width={timelineWidth}
      borderTop={`1px solid ${GreyGrey30}`}
      height={`24px`}
      pointerEvents="none"
    >
      {timelineMonths.map(month => (
        <MonthIndicator
          key={month.date.toString()}
          date={month.date}
          offset={month.offset}
        />
      ))}
    </Box>
  )
}
